export const CONTENTSTACK_PAGE_LIST = [
    '/',
    '/m/now-trending',
    '/m/rewards',
    '/m/sale',
    '/m/jcpenney-coupons/N-mpi6e5',
];